import * as React from 'react';
import {camelizeKeys} from 'humps';

import TapNovelWebView from '../shared/TapNovelWebView';
import MetaTags from '../shared/MetaTags';

import NavigationProp from '../../navigators/NavigationProp';
import {ContestGroupRouteProp} from '../../navigators/RouteProps';

import CurrentUser from '../../../domain/entities/writer/CurrentUser';

import {getUserAgent} from '../../../data/data_stores/net/UserAgent';

import TapNovelRestApi from '../../../data/data_stores/net/TapNovelRestApi';

interface ContestGroup {
  id: number;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: Array<string>;
}

export interface Params {
  contestGroupId: number;
}

export interface StateProps {
  navigation: NavigationProp;
  route: ContestGroupRouteProp;
  currentUser: CurrentUser | null;
}

export interface DispatchProps {}

interface Props extends StateProps, DispatchProps {
  children?: React.ReactNode;
}

const Show: React.FunctionComponent<Props> = props => {
  const {route, currentUser} = props;
  const {contestGroupId} = route.params;
  const [userAgent, setUserAgent] = React.useState<string | null>(null);
  const [contestGroup, setContestGroup] = React.useState<ContestGroup | null>(
    null,
  );

  React.useEffect(() => {
    TapNovelRestApi.get(`/contest_groups/${contestGroupId}.json`).then(
      response => {
        setContestGroup(
          camelizeKeys(response.body as any) as unknown as ContestGroup,
        );
      },
    );
    getUserAgent().then(ua => {
      setUserAgent(ua);
    });
  }, []);
  return userAgent && contestGroup ? (
    <>
      <MetaTags
        title={`${contestGroup.metaTitle} - TapNovelMaker`}
        description={contestGroup.metaDescription}
        keywords={contestGroup.metaKeywords.join(',')}
        noindex={true}
        indexifembedded={true}
      />
      <TapNovelWebView
        style={{flex: 1}}
        originWhitelist={['*']}
        path={`/contest_groups/${contestGroupId}?mode=maker&signed_in=${!!currentUser}`}
        userAgent={userAgent}
      />
    </>
  ) : null;
};

const areEqual = (prevProps: Readonly<Props>, nextProps: Readonly<Props>) => {
  return true;
};

export default React.memo(Show, areEqual);
